import { z } from "zod";

export const LOG_TABS = ["audit", "external"] as const;
export type LogTab = (typeof LOG_TABS)[number];

export interface ExternalLogFilterValues {
  readonly providerCode: string;
  readonly requestId: string;
  readonly businessRefType: string;
  readonly businessRefId: string;
  readonly limit: string;
}

export interface ExternalLogCriteria {
  readonly providerCode: string;
  readonly requestId: string;
  readonly businessRefType: string;
  readonly businessRefId: string;
  readonly limit: number;
}

export const externalLogFilterSchema = z.object({
  providerCode: z.string(),
  requestId: z.string(),
  businessRefType: z.string(),
  businessRefId: z.string(),
  limit: z.string()
    .regex(/^\d+$/, "조회 건수는 1~500 사이의 숫자로 입력해 주세요.")
    .refine((value) => Number(value) >= 1 && Number(value) <= 500, "조회 건수는 1~500 사이로 입력해 주세요."),
});

export function toExternalLogCriteria(values: ExternalLogFilterValues): ExternalLogCriteria {
  return {
    providerCode: values.providerCode.trim().toUpperCase(),
    requestId: values.requestId.trim(),
    businessRefType: values.businessRefType.trim().toUpperCase(),
    businessRefId: values.businessRefId.trim(),
    limit: Number(values.limit),
  };
}

export function parseLogTab(value: string | null): LogTab {
  return LOG_TABS.includes(value as LogTab) ? value as LogTab : "audit";
}

export function parseLogId(value: string | null): number | undefined {
  if (!value || !/^\d+$/.test(value)) return undefined;
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : undefined;
}
